import React from 'react'
import { Field as Input } from 'redux-form'

import Grid from '@material-ui/core/Grid'
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import {
    CheckboxInput,
    ReferenceSelectInput,
    SelectInput,
    TextInput,
    EnumInput
} from '../../Inputs'
import FieldDeleteDialog from './FieldDeleteDialog'
import { validateNumber, validatePositive } from './validate'


const renderOptions = (type, fieldName) => {
    switch (type) {
        case 'string':
            return stringOptions(fieldName)
        case 'number':
            return numberOptions(fieldName)
        case 'boolean':
            return null
        case 'reference':
            return referenceOptions(fieldName)
        case 'technicalData':
            return technicalDataOptions(fieldName)
        case 'date':
            return null
        case 'document':
            return documentOptions(fieldName)
        default:
            return null
    }
}

const stringOptions = (field) => (
    <React.Fragment>
        <Grid item xs={12} md={2} lg={4}>
            <Input
                name={`${field}.minLength`}
                component={TextInput}
                label="Largo mínimo"
                type="number"
                inputProps={{min: 0}}
                validate={[validateNumber, validatePositive]}
            />
        </Grid>
        <Grid item xs={12} md={2} lg={4}>
            <Input
                name={`${field}.maxLength`}
                component={TextInput}
                label="Largo máximo"
                type="number"
                inputProps={{min: 0}}
                validate={[validateNumber, validatePositive]}
            />
        </Grid>
        <Grid item xs={12}>
            <Input
                name={`${field}.enum`}
                component={EnumInput}
                label="Valores permitidos"
            />
        </Grid>
    </React.Fragment>
)

const numberOptions = (field) => (
    <React.Fragment>
        <Grid item xs={12} md={2} lg={4}>
            <Input
                name={`${field}.minimum`}
                component={TextInput}
                label="Mínimo"
                type="number"
                validate={[validateNumber]}
            />
        </Grid>
        <Grid item xs={12} md={2} lg={4}>
            <Input
                name={`${field}.maximum`}
                component={TextInput}
                label="Máximo"
                type="number"
                validate={[validateNumber]}
            />
        </Grid>
    </React.Fragment>
)

const referenceOptions = (field) => (
    <React.Fragment>
        <Grid item xs={12}>
            <Input
                name={`${field}.reference`}
                component={ReferenceSelectInput}
                label="Esquema"
                reference='esquemas-datos-tecnicos'
            />
        </Grid>
    </React.Fragment>
)

const technicalDataOptions = (field) => {
    return (
        <React.Fragment>
            <Grid item xs={12}>
                <Input
                    name={`${field}.choicesSchema`}
                    component={ReferenceSelectInput}
                    label="Dato Técnico"
                    reference='esquemas-datos-tecnicos'
                />
            </Grid>
        </React.Fragment>
    )
}

const documentOptions = (field) => (
    <React.Fragment>
        <Grid item xs={12}>
            <Input
              name={`${field}.extensions`}
              component={EnumInput}
              label="Extensiones (Ej: .pdf)"
              type="text"
              parse={(value, name) => value.map(val => val[0].indexOf('.') === 0 ? val : `.${val}`)}
            />
        </Grid>
        <Grid item xs={12}>
            <Input
                name={`${field}.fileType`}
                component={SelectInput}
                label="Tipo de Documento"
            >
                <MenuItem value={'CO'}>Contratos</MenuItem>
                <MenuItem value={'ES'}>Escrituras</MenuItem>
                <MenuItem value={'IN'}>Informes</MenuItem>
                <MenuItem value={'MC'}>Memoria de Cálculo</MenuItem>
                <MenuItem value={'OT'}>Otros</MenuItem>
                <MenuItem value={'PL'}>Planos</MenuItem>
            </Input>
        </Grid>
    </React.Fragment>
)

const styles = {
    field: {
        margin: '20px 0'
    },
    button: {
        icon: {
            marginRight: '10px'
        }
    }
}

export const SchemaField = withStyles(styles)((props) => {
    const { fieldName, index, fields, } = props
    return (
        <TableRow>
            {/* <TableCell></TableCell> */}
            <TableCell align="center">
                <Input
                    name={`${fieldName}.name`}
                    component={TextInput}
                    // label="Nombre"
                    required={true}
                />
            </TableCell>
            <TableCell align="center">
                <Input
                    name={`${fieldName}.type`}
                    component={SelectInput}
                    // label="Tipo"
                >
                    <MenuItem value={'string'}>Texto</MenuItem>
                    <MenuItem value={'number'}>Numérico</MenuItem>
                    <MenuItem value={'boolean'}>Si/No</MenuItem>
                    <MenuItem value={'date'}>Fecha</MenuItem>
                    <MenuItem value={'reference'}>Esquema</MenuItem>
                    <MenuItem value={'technicalData'}>Dato Técnico</MenuItem>
                    <MenuItem value={'document'}>Documento</MenuItem>
                </Input>
                {renderOptions(fields.get(index).type, fieldName)}
            </TableCell>
            <TableCell align="center" padding={"none"}>
                <Input
                    name={`${fieldName}.required`}
                    component={CheckboxInput}
                    // label="Requerido"
                />
            </TableCell>
            <TableCell align="center" padding={"none"}>
                <FieldDeleteDialog onDelete={() => fields.remove(index)} />
            </TableCell>
        </TableRow>
    )
})
